import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { ExecucaoOrcamentariaDetalheResponse } from "../typings";
import { FiltroPrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";

export default function useDetalhesExecucaoOrcamentaria(
  id?: string,
  query?: FiltroPrevisaoOrcamentaria
) {
  return useQuery<ExecucaoOrcamentariaDetalheResponse, AxiosError>(
    [`/v1/execucao-orcamentaria/${id}`, query],
    async () => {
      const { data } = await http.get<ExecucaoOrcamentariaDetalheResponse>(
        `/v1/execucao-orcamentaria/${id}`,
        {
          params: query,
        }
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}
